const styles = {
  root: {
    display: "block",
    padding: 0,
    margin: 0,
  },
};

export default styles;
